var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tour-popup" },
    [
      _c(
        "div",
        {
          staticClass: "modal modal-dashbrd",
          class: {
            "left in": _vm.windowInnerWidth <= 1300,
            "right in": _vm.windowInnerWidth > 1300,
          },
          attrs: { id: "modal_accounts", role: "dialog" },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-md" }, [
            _c("div", { staticClass: "modal-content acct-settings-left" }, [
              _c("div", {
                class: {
                  "modal-arrow-account": _vm.windowInnerWidth > 1300,
                  "modal-arrow": _vm.windowInnerWidth <= 1300,
                  "custom-modal-arrow":
                    _vm.windowInnerWidth > 1300 && _vm.roleId === 5,
                },
              }),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("img", {
                    staticClass: "close-btn",
                    attrs: {
                      src: "/static/images/icons/popup_close.svg",
                      alt: "close-icon",
                      "data-dismiss": "modal",
                    },
                    on: { click: _vm.closePopup },
                  }),
                  _vm._m(0),
                  _c("img", {
                    staticClass: "header-swoop",
                    attrs: {
                      src: "https://ramsdevstorage.blob.core.windows.net/customererrorpage/Header_swoop.png",
                      alt: "headerr-icon",
                    },
                  }),
                ]),
                _vm._m(1),
                _vm._m(2),
                _c(
                  "div",
                  { staticClass: "btn-next-div" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn custom-btn mr-16 emergo-white-button",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.backTour()
                          },
                        },
                      },
                      [_vm._v(" Back ")]
                    ),
                    _c("router-link", { attrs: { to: "/layout/dashboard" } }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn custom-btn emergo-green-button",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.endTour()
                              _vm.emitEvent()
                            },
                          },
                        },
                        [_vm._v(" Next ")]
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _vm._l(_vm.tourlength, function (index) {
                      return _c("span", {
                        key: index,
                        staticClass: "round-button",
                      })
                    }),
                    _c("span", { staticClass: "active-round-button" }),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c("success-popup"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-heading" }, [
      _c("img", {
        staticClass: "tour-icon",
        attrs: {
          src: require("../../../public/static/images/icons/settings_white_icon.svg"),
          alt: "setting-icon",
        },
      }),
      _vm._v(" Account Settings "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "dashbrd-txt tour-title-text" }, [
        _vm._v("Control your account and team’s access"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "description-txt pr-15" }, [
      _c("ul", [
        _c("li", [_vm._v("Control your team’s access to premium services")]),
        _c("li", [_vm._v("Customize frequency of alerts and notifications")]),
        _c("li", [
          _vm._v("Easily add or remove team members who receive updates"),
        ]),
        _c("li", [
          _vm._v(
            "Customize the RAMS dashboard for the data you need to manage your business"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }